import { type PreviewStaticModule } from '@/lib/builder/types'

import WebsiteBuilderFooterPreview from './preview/WebsiteBuilderFooterPreview.vue'

export const WebsiteFooterStaticModule: PreviewStaticModule = {
  preview: WebsiteBuilderFooterPreview,
}
